/** 横向聊天页手势只从左侧边缘发起，避开纵向滚动、文本选择及列表的左滑操作。无I/O。 */
export function chatPaneDrag(start, point, width) {
  if (!Number.isFinite(width) || width <= 0)
    return { cancelled: true, offset: 0, dismiss: false };
  const x = point.x - start.x;
  const y = point.y - start.y;
  if (Math.abs(y) > Math.max(8, Math.abs(x)))
    return { cancelled: true, offset: 0, dismiss: false };
  const offset = Math.max(0, Math.min(width, x));
  return {
    cancelled: false,
    offset,
    dismiss: offset >= Math.min(120, width * 0.3),
  };
}
